import { makeDeleteRequest } from '@/api/fetchCalls'

const FILE_API_BASE = `${process.env.REACT_APP_API_URL}/files`

export const deleteCustomerFileAttachment = async (
  id: number
): Promise<void> => {
  return makeDeleteRequest(FILE_API_BASE + `/customer-file-attachments/${id}`)
}
